import { getLocalTimeZone, today } from "@internationalized/date";
import { create } from "zustand";
import type { PaymentsDateRange, PaymentsSharedFilters } from "@/types/payments";
type PaymentsFiltersStore = PaymentsSharedFilters & {
  dealerships: string[];
  setSubsidiaryId: (id: string | null) => void;
  setDomaIds: (ids: string[]) => void;
  setDealerships: (dealerships: string[]) => void;
  setDateRange: (range: PaymentsSharedFilters["dateRange"]) => void;
  reset: () => void;
};

/**
 * Seule la fin de période est pré-remplie (jour courant) : sans date de début,
 * tout l'historique antérieur reste visible à l'ouverture.
 */
export const getDefaultDateRange = (): PaymentsDateRange => ({
  start: null,
  end: today(getLocalTimeZone())
});
const CLEARED_FILTERS: PaymentsSharedFilters = {
  subsidiaryId: null,
  domaIds: [],
  dateRange: null
};
export const usePaymentsFiltersStore = create<PaymentsFiltersStore>(set => ({
  ...CLEARED_FILTERS,
  dealerships: [],
  dateRange: getDefaultDateRange(),
  setSubsidiaryId: subsidiaryId => set({
    subsidiaryId,
    domaIds: [],
    dealerships: []
  }),
  setDomaIds: domaIds => set({
    domaIds
  }),
  setDealerships: dealerships => set({
    dealerships
  }),
  setDateRange: dateRange => set({
    dateRange
  }),
  reset: () => set({
    ...CLEARED_FILTERS,
    dealerships: []
  })
}));
export const usePaymentsSubsidiaryId = () => {
  return usePaymentsFiltersStore(_temp);
};
export const usePaymentsDomaIds = () => {
  return usePaymentsFiltersStore(_temp2);
};
export const usePaymentsDateRange = () => {
  return usePaymentsFiltersStore(_temp3);
};
export const usePaymentsDealerships = () => {
  return usePaymentsFiltersStore(_temp4);
};
function _temp(state) {
  return state.subsidiaryId;
}
function _temp2(state) {
  return state.domaIds;
}
function _temp3(state) {
  return state.dateRange;
}
function _temp4(state) {
  return state.dealerships;
}